import React from 'react';
import LoadingPlaceholder from '../../../muiComponents/LoadingPlaceholder';

const LoadingTaxPanel = () => {
    return (
        <>
            <LoadingPlaceholder variant='text' height={60} width={'100%'} />
            <LoadingPlaceholder variant='text' height={60} width={'100%'} />
            <LoadingPlaceholder variant='text' height={60} width={'100%'} />
            <LoadingPlaceholder variant='text' height={60} width={'100%'} />
            <LoadingPlaceholder variant='text' height={60} width={'100%'} />
            <LoadingPlaceholder variant='text' height={60} width={'100%'} />
        </>
    );
};

export default LoadingTaxPanel;
